import axios from 'axios';
import { message } from 'antd';
import { t } from '../locales';
import env from '../config/env';

const instance = axios.create({
  baseURL: env.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'osType': 'h5',
  },
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = `${token}`;
    }
    // 确保 POST 请求的数据被正确序列化
    if (config.method === 'post' && config.data) {
      config.data = JSON.stringify(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          window.location.href = '/login';
          message.error(t('common.sessionExpired'));
          break;
        case 403:
          message.error(t('common.noPermission'));
          break;
        case 404:
          message.error(t('common.resourceNotFound'));
          break;
        case 405:
          message.error(t('common.methodNotAllowed'));
          break;
        case 500:
          message.error(t('common.serverError'));
          break;
        default:
          message.error(error.response.data?.message || t('common.requestFailed'));
      }
    } else if (error.request) {
      message.error(t('common.networkError'));
    } else {
      message.error(t('common.requestConfigError'));
    }
    return Promise.reject(error);
  }
);

export default instance; 